import { selectDigitalMap } from 'ducks/universal/digitalMap';
import { useSelector } from 'react-redux';
import { useUrlQueryDisplayState } from '../useUrlQueryDisplayState';
import { useActiveRestaurant } from './useActiveRestaurant';

export const useIsViewOnlyMenu = () => {
  const digitalMap = useSelector(selectDigitalMap);
  const { activePinKey } = useUrlQueryDisplayState();
  const activeRestaurant = useActiveRestaurant();

  const pin = digitalMap?.pins.find((pin) => pin.key === activePinKey);

  return pin?.view_menu_restaurant_id && pin.view_menu_restaurant_id === activeRestaurant?.id;
};
